export default function NonConformitiesIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M11.55 5.7H11.941C14.6835 5.7 16.0547 5.7 16.5753 6.19256C17.0252 6.61833 17.2246 7.24555 17.1031 7.85299C16.9626 8.55571 15.8431 9.34757 13.6041 10.9313L9.94595 13.5187C7.70691 15.1024 6.58739 15.8943 6.44685 16.597C6.32537 17.2044 6.52477 17.8317 6.97473 18.2574C7.49526 18.75 8.86652 18.75 11.609 18.75H12.45M8.4 5.7C8.4 7.19117 7.19117 8.4 5.7 8.4C4.20883 8.4 3 7.19117 3 5.7C3 4.20883 4.20883 3 5.7 3C7.19117 3 8.4 4.20883 8.4 5.7ZM21 18.3C21 19.7912 19.7912 21 18.3 21C16.8088 21 15.6 19.7912 15.6 18.3C15.6 16.8088 16.8088 15.6 18.3 15.6C19.7912 15.6 21 16.8088 21 18.3Z"
        stroke={stroke || "#474E57"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
